import { NotificationListsUserModel } from "./NotificationListsUser.model";

export class NotificationListsUser extends NotificationListsUserModel {
    // Add custom methods here
}
